import React, { Component } from 'react';

import api from '../../../utils/api';
class Overview extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      loading: true,
      text: undefined
    };
  }

  componentWillMount() {
    api
      .get('/auth/welcome_text')
      .then(({ data }) => this.setState({ text: data.text, loading: false }));
  }

  render() {
    const { loading, text } = this.state;

    if(loading) {
      return 'laden...';
    }

    return (
      <div>
        <div dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    );
  }
}

export default Overview;
